export default __webpack_public_path__ + "static/media/no-color-icon.003dc96e.png";